import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Typography, Link } from "@mui/material";
import { ROUTES } from "../../../constants";

/**
 * Renders exercise name as a link to exercise details when exerciseId is valid,
 * otherwise renders plain text.
 */
export default function ExerciseNameLink({
  exerciseId,
  name,
  variant = "body2",
  className,
}) {
  const isValidLink =
    exerciseId && typeof exerciseId === "string" && exerciseId !== "super_set";

  if (isValidLink) {
    if (className) {
      return (
        <RouterLink to={`${ROUTES.EXERCISE_DETAILS}/${exerciseId}`} className={className}>
          {name}
        </RouterLink>
      );
    }
    return (
      <Link
        component={RouterLink}
        to={`${ROUTES.EXERCISE_DETAILS}/${exerciseId}`}
        underline="hover"
        color="primary"
        sx={{
          fontWeight: variant === "subtitle2" ? 600 : 500,
          "&:hover": { textDecoration: "underline" },
        }}
      >
        <Typography component="span" variant={variant} sx={{ fontWeight: "inherit" }}>
          {name}
        </Typography>
      </Link>
    );
  }

  if (className) {
    return <span className={className}>{name}</span>;
  }

  return (
    <Typography variant={variant} fontWeight={variant === "subtitle2" ? 600 : 500} color="text.primary">
      {name}
    </Typography>
  );
}
